<template>
	<div class="sp-template">
		<div class="h-title">认领清单</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="searchData" class="header-search__form" size="small" label-width="90px">
					<el-form-item label="开始日期">
						<el-date-picker v-model.lazy="searchData.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
					</el-form-item>
					<el-form-item label="结束日期">
						<el-date-picker v-model.lazy="searchData.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
					</el-form-item>
          <el-form-item label="快递单号">
						<el-input v-model.lazy="searchData.expressCode" clearable  placeholder="快递单号"></el-input>
					</el-form-item>
					<el-form-item>
					</el-form-item>
          <div class="search-form__buttons">
						<el-button v-if="in_configs(41501)" type="primary" size="small" @click="onSubmit">搜 索</el-button>
						<el-button v-if="in_configs(41501)" size="small" @click="reset">清 空</el-button>
          </div>
				</el-form>
			</div>
      <div class="table-operate__buttons">
        <el-tabs v-model="searchData.claimed" @tab-click="onSubmit">
          <el-tab-pane label="未认领" name="false"></el-tab-pane>
          <el-tab-pane label="已认领" name="true"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
					<el-button v-if="in_configs(41502)" size="small" @click="dialogFormVisible = true">新建</el-button>
        </div>
      </div>
			<el-table :data="tableData" tooltip-effect="dark" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="warehouseId" label="仓库">
          <template slot-scope="scope">
            {{warehouseDataMap[scope.row.warehouseId]}}
					</template>
          
        </el-table-column>
				<el-table-column prop="expressCompany" label="快递公司"></el-table-column>
				<el-table-column prop="expressCode" label="快递单号"></el-table-column>
				<el-table-column label="箱号">
					<template slot-scope="scope">
						<p v-for="(d, i) in  scope.row.cartonCodes ? scope.row.cartonCodes.split(',') : []" :key="i">{{d}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="qty" label="到货箱数"></el-table-column>
				<el-table-column prop="weight" label="重量(kg)"></el-table-column>
				<el-table-column prop="name" label="图片">
					<template slot-scope="scope">
						<sp-img :url-arr="scope.row.imgUrl" :show-one="true"></sp-img>
					</template>
				</el-table-column>
				<el-table-column prop="claimant" label="认领人"></el-table-column>
				<el-table-column prop="createDate" label="创建时间"></el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchData.currentPage" :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
			<!-- 弹窗 -->
			<el-dialog title="新建认领单" class="cliam-list__dialog" :visible.sync="dialogFormVisible" width="500px">
				<el-form :model="form" size="small" :rules="formRule" ref="form" label-width="100px">
					<el-form-item label="仓库名称"  prop="warehouseId">
						<el-select v-model="form.warehouseId" filterable placeholder="请选择">
							<el-option  v-for="(d, i) in warehouseData" :key="i" :label="d.name" :value="d.id" ></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="快递公司"  prop="expressCompany">
						<el-input v-model="form.expressCompany" auto-complete="off"></el-input>
					</el-form-item>
					<el-form-item label="快递单号"  prop="expressCode">
						<el-input v-model="form.expressCode" auto-complete="off"></el-input>
					</el-form-item>
					<el-form-item label="到货箱数"  prop="qty">
						<el-input v-model="form.qty" auto-complete="off" type="number"></el-input>
					</el-form-item>
					<el-form-item label="认领箱号"  prop="cartonCodeTags">
						<el-tag :key="tag" v-for="tag in form.cartonCodeTags" closable :disable-transitions="false" @close="handleClose(tag)">
							{{tag}}
						</el-tag>
						<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
						</el-input>
						<el-button v-else class="button-new-tag" size="small" @click="showInput">添加箱号</el-button>
					</el-form-item>
					<el-form-item label="总重量(kg)"  prop="weight">
						<el-input v-model="form.weight" auto-complete="off" type="number"></el-input>
					</el-form-item>
					<el-form-item label="图片上传" >
						<el-upload action="#" :file-list="imgFile" list-type="picture-card" :limit="1" :on-change="imgChange" :auto-upload="false">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-dialog :visible.sync="dialogVisible" append-to-body>
						<img width="100%" :src="dialogImageUrl" alt="">
					</el-dialog>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
					<el-button size="small" type="primary" @click="saveClaim()">确 定</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
import {mapMutations} from 'vuex'
export default {
  data() {
    return {
      //搜索数据
      searchData: {
        expressCode: "",
        claimed: "false",
        currentPage: 1,
        pageSize: 100,
        startDate: "",
        endDate: ""
      },
      //表单数据
      tableData: [
        {
          name: "666",
          src: ["/static/img/img.jpg", "/static/img/img.jpg"],
          arr: [
            {
              test: "21321"
            },
            {
              test: "21321"
            }
          ]
        }
      ],
      total: 0,
      warehouseData: [],
      warehouseDataMap: {},
      multipleSelection: [], //表单选中的列
      //新建弹窗
      dialogFormVisible: false,
      form: {
        warehouseId: "",
        expressCompany: "",
        expressCode: "",
        qty: "",
        cartonCodeTags: [],
        weight: ""
      },
      imgFile: [],
      formRule: {
        warehouseId: [
          {
            required: true,
            message: "请选择仓库",
            trigger: "change"
          }
        ],
        expressCompany: [
          {
            required: true,
            message: "请填写快递公司",
            trigger: "blur"
          }
        ],
        expressCode: [
          {
            required: true,
            message: "请填写快递单号",
            trigger: "blur"
          }
        ],
        qty: [
          {
            required: true,
            message: "请填写总箱数",
            trigger: "blur"
          }
        ],
        cartonCodeTags: [
          {
            required: true,
            message: "请填写箱号",
            trigger: "blur"
          }
        ],
        weight: [
          {
            required: true,
            message: "请填写总重量",
            trigger: "blur"
          }
        ]
      },
      addImg: "",
      inputVisible: false,
      inputValue: "",
      //上传图片
      dialogImageUrl: "",
      dialogVisible: false,
      currentPage: 2 //点前页
    };
  },
  created() {
    if(this.$route.query.from === 'orderoperation/arrivalgoods') {
      let arr = [{"id":41501,"label":"搜索"},{"id":41502,"label":"新建"}]
      this.pageConfig = arr
      sessionStorage.setItem('configs', JSON.stringify(arr))
    }
    setTimeout(() => {
      this.onSubmit();
      this.queryWarehouseData();
    }, 1000);
  },
  computed: {
    pageConfig: {
      get() {
        return this.$store.state.pageConfig
      },
      set(value) {
        return this.setPageConfig(value)
      }
    }
  },
  methods: {
    ...mapMutations([
      'setPageConfig'
    ]),
    //搜索
    onSubmit() {
      let _this = this;
      _this.$request1
        .post(
          '/claim/query',
          {
              id: "",
              warehouseId: "",
              expressCompany: "",
              expressCode: _this.searchData.expressCode,
              orderId: "",
              claimed: _this.searchData.claimed,
              startDate: _this.searchData.startDate,
              endDate: _this.searchData.endDate,
              currentPage: _this.searchData.currentPage,
              pageSize: _this.searchData.pageSize
            },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          console.log(res);
          if (res.data.success) {
            _this.tableData = res.data.data;
            _this.total = res.data.total;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    reset() {
      this.searchData = {
        expressCode: "",
        claimed: "false",
        currentPage: 1,
        pageSize: 100,
        startDate: "",
        endDate: ""
      }
      this.onSubmit()
    },
    queryWarehouseData() {
      this.$request1({
        method: 'GET',
        url: '/warehouse/load',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.success) {
            this.warehouseData = res.data.data;
            this.warehouseData.forEach((d, i) => {
              this.warehouseDataMap[d.id] = d.name;
            });
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    saveClaim() {
      let _this = this;
      let _valid = true;
      console.log(_this.form);
      _this.$refs["form"].validate(valid => {
        if (!valid) {
          _valid = false;
        }
      });
      if (!_valid) {
        return false;
      }
      let formData = new FormData();

      for (var key in _this.form) {
        formData.append(key, _this.form[key]);
      }
      formData.append("cartonCodes", _this.form.cartonCodeTags.toString());
      formData.append("pic", _this.addImg);

      this.$request1
        .post(
          '/claim',
          formData,
          {
            withCredentials: true
          }
        )
        .then(res => {
          console.log(res);
          if (res.data.success) {
            this.dialogFormVisible = false;
            this.$message.success("success");
            _this.addImg = "";
            _this.imgFile = [];
            for (var key in _this.form) {
              if (typeof _this.form[key] == "object") {
                _this.form[key] = [];
              } else {
                _this.form[key] = "";
              }
            }
            this.onSubmit();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    imgChange(file, fileList) {
      this.addImg = file.raw;
    },
    //表格多选按钮
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    //上传图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //标签
    handleClose(tag) {
      this.form.cartonCodeTags.splice(this.form.cartonCodeTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.form.cartonCodeTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchData.pageSize = val;
      this.onSubmit();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchData.currentPage = val;
      this.onSubmit();
    }
  }
};
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/orderOperation/claimlist.vue